import { GenderEnum } from "./enums/gender.enum";

export class Customer extends Object {
    public gender!: GenderEnum;
    public firstName!: string;
    public lastName!: string;
    public streetName!: string;
    public houseNumber!: string;
    public postalCode!: string | number | undefined;
    public location!: string;
    public telephone!: string;
    public email!: string;
    public country: string = "BE";
    public invoiceAddressIsSameToPostalAddress: boolean = true;
    public invoicingAddressStreetName!: string;
    public invoicingAddressHouseNumber!: string;
    public invoicingAddressBusNumber!: string;
    public invoicingAddressPostalCode!: string | number | undefined;
    public invoicingAddressLocation!: string;
    public invoicingAddressCountry!: string;
    public invoiceAddressFirstName!: string;
    public invoiceAddressLastName!: string;
    public customerNumber!: string;
    public vatNumber!: string;
    public loginName!: string;
    
    override toString = () => 
        "Aanspreking: " + GenderEnum[this.gender] + "\n"+
        "Voornaam: " + this.firstName + "\n" +
        "Achternaam: " + this.lastName + "\n" +
        "Straatnaam + Huisnr. (+ busnr.): " + this.streetName + " " + this.houseNumber + "\n" +
        "Postcode + Gemeente: " + this.postalCode + " " + this.location + "\n" +
        "Telefoon: " + this.telephone + "\n" +
        "E-mail: " + this.email + "\n" +
        "Land: " + this.country + "\n" +
        "Verbruiksadres en facturatieadres zijn hetzelfde: " + this.invoiceAddressIsSameToPostalAddress + "\n" +
        "Facturatieadres: " + this.invoiceAddressIsSameToPostalAddress ? this.invoicingAddressStreetName + " " 
        + this.invoicingAddressHouseNumber + ", " + this.invoicingAddressPostalCode + " " + this.invoicingAddressLocation + " " + this.invoicingAddressCountry
        : this.streetName + " " + this.houseNumber + ", " + this.postalCode + " " + this.location + "\n";

}